<script lang="ts">
	export let blok;
</script>

<div>
	{#if blok.title}
		<h2>{blok.title}</h2>
	{/if}
	{#if blok.desc}
		<p class="lg:text-lg">{blok.desc}</p>
	{/if}
</div>
